import React from 'react'
import { Form, Formik } from 'formik'

import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'

export default function CustomerForm({ onCancel, onSubmit, loading, initialValues }) {
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                fullName: '',
                phoneNumber: '',
                ...initialValues,
            }}
        >
            <Form>
                <div className="columns">
                    <div className="column">
                        <Input
                            name="fullName"
                            label="Мижоз номи"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="phoneNumber"
                            label="Телефон рақам"
                            validate={required}
                            disabled={loading}
                        />
                    </div>
                </div>

                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button
                            onClick={onCancel}
                            icon="close-outline"
                            text="Ёпиш"
                            className="is-danger"
                        />
                    </div>
                    <div className="button-wrapper">
                        <Button
                            loading={loading}
                            text="Сақлаш"
                            icon="add-outline"
                            type="submit"
                            className="is-success"
                        />
                    </div>
                </div>
            </Form>

        </Formik>
    )
}
